import axios from "axios";
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const ticketSchema = {
  ticket_id: Joi.number().integer().required(),
  amount: Joi.number().integer().required(),
  price: Joi.number().allow(''),
};

const attendeeSchema = {
  ticket_id: Joi.number().integer().required(),
  first_name: Joi.string().required(),
  last_name: Joi.string().required(),
  date_of_birth: Joi.string(),
  phone: Joi.string(),
  email: Joi.string(),
  custom_data: Joi.object().required(),
};

const recipientSchema = Joi.object().keys({
  full_name: Joi.string(),
  phone: Joi.string().required(),
  email: Joi.string().required(),
  suite_num: Joi.string().allow(''),
  address: Joi.string(),
  city: Joi.string(),
  province: Joi.string(),
  postal_code: Joi.string(),
});

export const schema = Joi.object().keys({
	ticket: Joi.array().min(1).items(Joi.object(ticketSchema)),
	attendee: Joi.array().min(1).items(Joi.object(attendeeSchema)),
	recipient: recipientSchema,
});

export default function placeOrder(schoolId, orderInfo) {

  if(!schoolId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing school ID')
      })
    })
  }

  let validateResult = Joi.validate(orderInfo, schema);
  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/place_order/${schoolId}/`,
      'method': 'POST',
      'data': JSON.stringify(orderInfo),
      'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data)
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/ticket/placeOrder.js